import Crud from '../views/Painel/Crud'
import Entity from '../views/Painel/View'

let routes = {
    path: '/paineis',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/paineis/view/:id?',
            name: 'ViewPainel',
            component: Entity,
            meta: {
                pageTitle: "Visualizar Painel",
                breadcrumb: [
                    {
                        text: "Paineis",
                        active: false,
                        to: '/paineis',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/paineis',
            name: 'list-paineis',
            component: Crud,
            meta: {
                pageTitle: "Lista de Paineis",
                breadcrumb: [
                    {
                        text: "Paineis",
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
